import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import s from "./folderMapper.scss";
import cx from "classnames";
import LoaderIcon from "Components/loader/LoaderIcon";
import { t } from "i18next";

class FolderMapper extends Component {
  constructor(props) {
    super(props);

    let values = {};
    props.folderNames.forEach((folder) => {
      if (props.initialValues) {
        values[folder] = props.initialValues[folder];
      } else {
        values[folder] = false;
      }
    });

    this.state = {
      values,
      activeSelectAll: undefined,
    };
  }

  getValues = () => {
    return this.state.values;
  };

  updateValue = (e) => {
    const folderName = e.target.dataset.folder;
    const destinationName = e.target.value;
    const newValues = { ...this.state.values, [folderName]: destinationName };
    this.setState({ values: newValues, activeSelectAll: undefined });
  };

  selectAll = (e) => {
    const destination = e.target.dataset.destination;

    let newValues = {};
    this.props.folderNames.forEach((folder) => {
      newValues[folder] = destination;
    });

    this.setState({ values: newValues, activeSelectAll: destination });
  };

  render() {
    const {
      className,
      folderNames,
      folderCounters,
      defaultSelection,
      itemsLabel,
      allItems,
      destinations,
      destinationLabels,
      isLoading,
      error,
      errorGettingFolders,
      showInboxFirst = true,
    } = this.props;

    const { values } = this.state;

    if (errorGettingFolders) {
      return (
        <div className={className}>
          <div className={s.folderMapper}>
            <div>{t("errorMsg.vaultFoldersError")}</div>
          </div>
        </div>
      );
    }

    if (isLoading && !error) {
      return (
        <div className={className}>
          <div className={s.folderMapper}>
            <LoaderIcon className={s.loaderIcon} iconSize="3rem" />
          </div>
        </div>
      );
    }

    return (
      <div className={cx(className, { [s.withErrors]: !!error })}>
        <div className={s.folderMapper}>
          <div className={cx(s.row, s.destinations)}>
            <div>{itemsLabel}</div>
            {[...destinationLabels].map((title) => (
              <div className={s.labelDestination} key={title}>
                {title}
              </div>
            ))}
          </div>
          <div className={s.foldersList}>
            <div className={cx(s.row, s.folder, s.firstLine)}>
              <div>{allItems}</div>
              {destinations.map((dest) => (
                <input
                  className={s.radioInput}
                  key={dest}
                  type="radio"
                  name={`${dest}|all`}
                  onChange={this.selectAll}
                  data-destination={dest}
                  checked={this.state.activeSelectAll === dest}
                />
              ))}
            </div>

            {/* INBOX comes always first! */}
            {showInboxFirst && (
              <div className={cx(s.row, s.folder)}>
                <div>INBOX {folderCounters && `(${folderCounters["INBOX"]})`}</div>
                {destinations.map((dest) => (
                  <input
                    className={s.radioInput}
                    key={dest}
                    type="radio"
                    name={`${dest}|INBOX`}
                    onChange={this.updateValue}
                    data-folder={"INBOX"}
                    value={dest}
                    checked={values["INBOX"] ? values["INBOX"] === dest : defaultSelection === dest}
                  />
                ))}
              </div>
            )}

            {/* then all the others folders */}
            {_.compact(
              folderNames.map((folder) => {
                if (folder === "INBOX") return null; /* was handled manually before */

                return (
                  <div className={cx(s.row, s.folder)} key={folder}>
                    <div>
                      {folder} {folderCounters && `(${folderCounters[folder]})`}
                    </div>
                    {destinations.map((dest) => (
                      <input
                        className={s.radioInput}
                        key={dest}
                        type="radio"
                        name={`${dest}|${folder}`}
                        onChange={this.updateValue}
                        data-folder={folder}
                        value={dest}
                        checked={values[folder] ? values[folder] === dest : defaultSelection === dest}
                      />
                    ))}
                  </div>
                );
              })
            )}
          </div>
        </div>
        {error && <div className={s.errorMsg}>{error}</div>}
      </div>
    );
  }
}

// //FolderMapper.propTypes = {
//   folderNames: PropTypes.array,
//   destinations: PropTypes.array,
//   destinationLabels: PropTypes.array,
//   defaultSelection: PropTypes.string,
//   isLoading: PropTypes.bool
// };

export default FolderMapper;
